<template>
  <div class="form-box">
    <p class="scoped-tips">*最多可选3个擅长语言</p>
    <el-form ref="scopedForm" :model="scopedForm" :rules="rules" v-if="ifForm==1">
      <el-form-item prop="checkItem">
        <div class="scoped-list">
          <el-checkbox-group v-model="scopedForm.checkItem" :min="0" :max="3">
            <el-checkbox v-for="item in itemData" :label="item.code" :disabled="item.status===2 ? true : false "
              :key="item.id" class="scoped-item">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import langC from "@/common/edit/lang";

export default {
  name: "editLanguage",
  props: ["ifForm", "isCall", "params"],
  data () {
    return {
      rules: {
        // checkItem: [{ required: true, message: '*请选择领域', trigger: 'blur' }],
      },
      scopedForm: {
        checkItem: []
      },
      itemData: [],
      deleteLangList: []
    };
  },
  components: {},
  watch: {
    isCall () {
      this.resetForm();
    }
  },
  created () {
    if (this.itemData.length == 0) {
      this.getData();
    }
    if (this.params) {
      this.scopedForm.checkItem = this.params.list || [];
      this.deleteLangList = this.params.list || [];
    }
  },
  methods: {
    resetForm () {
      // 清空
      if (this.$refs.scopedForm) {
        this.$refs.scopedForm.resetFields();
      }
    },
    getData () {
      var params = {
        dataType: "lang"
      };
      this.catReq1Service("/api/v1/common/queryAllLang", params)
        .then(response => {
          if (response && response.resultCode === "1") {
            var result = response.result;
            // console.log(result);
            if (result) {
              this.itemData = result;
              langC.init(this.itemData);
            }
          } 
        })
        .catch(error => {
          // this.$message({
          //   message: "网络出错!",
          //   type: "error"
          // });
          // console.log(error);
        });
    },
    submit (callback) {
      // 提交
      var that = this;
      this.$refs.scopedForm.validate(valid => {
        if (valid) {
          let ary = [];
          for (let i = 0; i < that.deleteLangList.length; i++) {
            that.itemData.forEach(item => {
              if (item.code === that.deleteLangList[i]) {
                ary.push({
                  langName: item.name,
                  langCode: item.code
                });
              }
            });
          }
          langC.submit(
            {
              deleteLangList: ary,
              addLangList: langC.toDataAry(this.scopedForm.checkItem)
            },
            () => {
              callback &&
                callback({
                  list: langC.toDataAry(this.scopedForm.checkItem)
                });
            }
          );
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    onSubmit () {
      // console.log(this.ifForm, "submit!");
    }
  }
};
</script>

<style lang="less" scoped>
.form-box {
  margin: 0 auto;
  width: 860px;
  text-align: left;
  position: relative;
  padding: 0px 10px;
  padding: 0 50px;
}
.scoped-list,
.scoped-tips {
  padding-left: 78px;
}
.scoped-item {
  margin: 0;
  width: 120px;
}
.scoped-tips {
  position: absolute;
  top: -20px;
  left: 10px;
  padding-top: 6px;
  font-size: 12px;
  line-height: 12px;
  color: #999999;
}
</style>